const EMPTY_STYLES = {};
const EMPTY_STYLES_FN = () => EMPTY_STYLES;

export default EMPTY_STYLES_FN;
